import type { FC } from "react";
import { CalculatorResultAmount } from "web_myplann/Calculators/Components/CalculatorResultAmount";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatRate } from "web_myplann/Shared/Utils/percentageFormatters";

type Props = {
	amount: number;
	rate: number;
	rateFractionDigits?: number;
};

export const CalculatorRateAmount: FC<Props> = ({
	amount,
	rate,
	rateFractionDigits = 2,
}) => {
	const { t } = useResource();

	return (
		<CalculatorResultAmount
			amount={amount}
			meta={t(Resources.Calculators.Result.RateMeta, {
				unit: t(Resources.Calculators.Result.Unit),
				rate: formatRate(rate, rateFractionDigits),
			})}
		/>
	);
};
